<template>
  <div v-if="this.loading_page">
    <v-sheet
      :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class="pa-3"
    >
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <v-row>
      <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">ดูรายการขายดีของสาขา</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 pt-0">
        <v-card elevation="4" style="border-radius: 15px">
          <v-card-text>
            <div class="pa-4">
              <v-form ref="#">
                <v-row>
                  <!-- ค้นหาล็อต -->
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div class="d-flex">
                      <div class="title_form_main">
                        <div class="logo_timeline">
                          <img src="@/assets/arin_assets/box.png" />
                        </div>
                      </div>
                      <div class="header-content py-1 pl-5 pr-5 text-center">
                        <div class="content-font">ดูรายการขายดีของสาขา</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="11" lg="11" xl="11" cols="12">
                    <v-form-group>
                      <label class="label_form_text"
                        >ชื่อสินค้า <span class="required--text">*</span></label
                      >
                      <v-autocomplete
                        class="input-radius"
                        v-model="product_id"
                        @change="addItem"
                        :items="product_list"
                        item-value="product_code"
                        placeholder="ค้นหาสินค้า..."
                        single-line
                        solo
                        ref="product_list"
                        :item-text="name"
                        :search-input.sync="search"
                        single
                        outlined
                        dense
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <p class="fullName">{{ item.name }}</p>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-form-group>
                  </v-col>
                  <v-col
                    class="mt-2"
                    xs="12"
                    sm="12"
                    md="1"
                    lg="1"
                    xl="1"
                    cols="12"
                  >
                    <div
                      @click="showBranch()"
                      class="title_page ma-3"
                      style="justify-content: center"
                    >
                      <v-btn
                        type="button"
                        class="btn_add_data"
                        elevation="4"
                        large
                        >ค้นหา</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="mb-10">
        <Transition name="slide-fade">
          <v-card v-if="show" elevation="4" style="border-radius: 15px">
            <v-card-text>
              <div class="pa-4">
                <v-form ref="#">
                  <v-row>
                    <v-col cols="12" class="mt-5">
                      <div class="d-flex">
                        <div class="text-center">
                          <div class="content-header-title">ข้อมูลสินค้า</div>
                        </div>
                      </div>
                    </v-col>
                    <v-row class="border-color-milk">
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <div class="text_title">
                          ชื่อสินค้า :
                          <span class="text_detail">
                            {{ product_first.product_code }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <div class="text_title">
                          ชื่อสินค้า :
                          <span class="text_detail">
                            {{ product_first.name }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <div class="text_title">
                          ชื่อทางการแพทย์ :
                          <span class="text_detail">
                            {{ product_first.name_sci }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <div class="text_title">
                          จำนวนคงเหลือในคลังร้านค้า :
                          <span class="text_detail">{{
                            product_first.types_name != null
                              ? product_first.types_name
                              : "-"
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>

                    <v-col cols="12" class="mt-5">
                      <div class="d-flex">
                        <div class="text-center">
                          <div class="content-header-title">
                            รายการยอดขายแต่ละสาขา
                          </div>
                        </div>
                      </div>
                      <v-row class="align-center mb-2">
                        <v-col xs="12" sm="6" md="3" lg="3" xl="3" class="mt-5">
                          <v-text-field
                            v-model="searchDateStart"
                            label="วันที่เริ่มต้น"
                            type="date"
                            class="input-radius"
                            color="#D6BFAF"
                            outlined
                            dense
                            @change="checkDate"
                          ></v-text-field>
                        </v-col>

                        <v-col xs="12" sm="6" md="3" lg="3" xl="3" class="mt-5">
                          <v-text-field
                            v-model="searchDateEnd"
                            label="วันที่สิ้นสุด"
                            type="date"
                            class="input-radius"
                            color="#D6BFAF"
                            outlined
                            dense
                            @change="checkDate"
                          ></v-text-field>
                        </v-col>
                        <v-col xs="0" sm="0" md="2" lg="2" xl="2"> </v-col>
                        <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                          <v-text-field
                            color="#D6BFAF"
                            class="input-radius"
                            append-icon="mdi-magnify"
                            hide-details="auto"
                            v-model="searchTable"
                            placeholder="ค้นหา..."
                            single-line
                            outlined
                            dense
                            @change="checkDate"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-row class="border-color-milk">
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">ชื่อสาขา</th>
                                <th class="text-left">ยอดขายของแต่ละสาขา</th>
                                <th class="text-left">
                                  จำนวนคลังคงเหลือแต่ละสาขา
                                </th>
                                <th class="text-left">หน่วยนับ</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(productall, index) in show_data_list"
                                :key="index"
                              >
                                <td>{{ productall.name }}</td>
                                <td>
                                  {{
                                    productall.total_qty !== null
                                      ? productall.total_qty
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    productall.in_stock !== null
                                      ? productall.in_stock
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    productall.min_unit_name
                                      ? productall.min_unit_name
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-col cols="12">
                        <div
                          class="text-center"
                          @click="
                            searchBestSell()
                          "
                        >
                          <v-pagination
                            color="#d0b19b"
                            v-model="page"
                            :total-visible="7"
                            :length="page_all"
                          ></v-pagination>
                        </div>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </Transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Search_stock",
  data() {
    return {
      loading_page: true,
      show: false,
      product_id: null,
      page: 1,
      size: 10,
      page_all:1,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "รายละเอียดสินค้า",
          disabled: false,
          // href: '#',
        },
        {
          text: "ดูรายการขายดีของสาขา",
          disabled: false,
          // href: '#',
        },
      ],
      product_list: [],
      product_first: "",
      data_list: [],
      search: "",
      show_data_list: [],
      searchTable: "",
      searchDateStart: "",
      searchDateEnd: "",
      no: 1,
    };
  },
  methods: {
    displayText(item) {
      return `${item.product_name} (${item.lot_no}) - Exp. ${item.date_expired}`;
    },
    getBranchAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/warehouse/productall", config).then((res) => {
        if (res.data.successful === true) {
          this.product_list = res.data.productList;
          this.loading_page = false;
        }
      });
    },
    async showBranch(id) {
      this.loading_page = true;
      this.data_list = [];
      this.product_id = id ? id : this.product_id;
      const data = {
        product_code: this.product_id,
        page: this.page,
        size: this.size,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.post(
        "/warehouse/bestsalesproducbranchtall",
        data,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.BranchSaleList.data;
          this.page_all = res.data.BranchSaleList.totalPages;
          this.show_data_list = this.data_list
          this.getProductFirst();
          this.loading_page = false;
          this.show = true;
        }
      });
    },
    async getProductFirst() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      await HTTP_ARIN.get(
        "/warehouse/productfirst?product_code=" + this.product_id,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.product_first = res.data.ProductFirst;
          this.loading_page = false;
        }
      });
    },
    async searchBestSell() {
      const data = {
        product_code: this.product_id,
        searchValue: this.searchTable,
        searchDateStart: this.searchDateStart,
        searchDateEnd: this.searchDateEnd,
        page: this.page,
        size: this.size,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.post(
        "/warehouse/bestsalesproducbranchtall",
        data,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.BranchSaleList.data;
          this.show_data_list = this.data_list
          this.loading_page = false;
          this.show = true;          
        }
      });
    },
    checkDate(){
      if(this.searchDateStart == '' || this.searchTable == '' || this.searchDateEnd == ''){
        this.searchBestSell();
      }      
    }
  },
  mounted() {
    this.getBranchAll();
    if (this.$route.params.id && this.$route.params.id != "-") {
      this.showBranch(this.$route.params.id);
    }
  },
  watch: {
    searchTable() {
      this.searchBestSell();
    },
    searchDateStart() {
      if (!(!this.searchDateStart && this.searchDateStart == '') && !(!this.searchDateEnd && this.searchDateEnd == '')) {
        this.searchBestSell();
      }
    },
    searchDateEnd() {
      if (!(!this.searchDateStart && this.searchDateStart == '') && !(!this.searchDateEnd && this.searchDateEnd == '')) {
        this.searchBestSell();
      }
    },
  },
};
</script>

<style>
.btn_add_data {
  font-size: 16px;
  color: rgb(255, 255, 255) !important ;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 100%;
}

.border-color-milk {
  border: 1px solid #d6bfaf;
  border-radius: 10px;
  margin: 0;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 22px;
}

.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.logo_timeline {
  padding: 6px;
}

.logo_timeline > img {
  max-width: 25px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616a6b !important;
}

.input-radius {
  border-radius: 10px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

@media only screen and (max-width: 600px) {
  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }
}

.text_title {
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}
</style>
